export const SET_IS_GALLERY_LOADING = 'SET_IS_GALLERY_LOADING';
export const SET_NEW_START_AT = 'SET_NEW_START_AT';
export const SET_IS_LAST_ASSET = 'SET_IS_LAST_ASSET';
export const SET_COLLECTION_DATA = 'SET_COLLECITON_DATA';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_SELECTED_NFT = 'SET_SELECTED_NFT';
